import { EGreenChoicesActions, GreenChoicesActions } from "@edp-store/actions/green-choices.actions";
import { IGreenChoicesState, initialGreenChoices } from "@edp-store/state/green-choices.state";

export function greenChoicesReducers(state = initialGreenChoices, action: GreenChoicesActions): IGreenChoicesState {
    switch (action.type) {
        case EGreenChoicesActions.SetShowModalMoreGreenChoices: {
            return {
                ...state,
                isShowModal: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}
